function svgToDataUrl(svg) {
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
}

function makeImage(title, subtitle, colorA, colorB) {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="720">
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="${colorA}"/>
          <stop offset="100%" stop-color="${colorB}"/>
        </linearGradient>
      </defs>
      <rect width="100%" height="100%" fill="url(#g)" />
      <rect x="60" y="60" width="1160" height="600" rx="24" fill="rgba(0,0,0,0.35)" />
      <text x="110" y="220" font-family="Helvetica, Arial, sans-serif" font-size="56" fill="#ffffff">${title}</text>
      <text x="110" y="290" font-family="Helvetica, Arial, sans-serif" font-size="28" fill="rgba(255,255,255,0.8)">${subtitle}</text>
    </svg>
  `;
  return svgToDataUrl(svg);
}

export const criteria = [
  "Story",
  "Originality",
  "Historical Context",
  "Visual Impact",
  "Purpose",
  "Overall Impression"
];

export const artworks = [
  {
    id: 101,
    title: "The Spanish Singer",
    artist: "Edouard Manet",
    date: "1860",
    medium: "Oil on canvas",
    culture: "French",
    description:
      "This painting, which reflects the Parisian vogue for Spanish art and culture during the Second Empire, won Manet his first popular and critical success in his debut at the Salon of 1861. Though the picture was admired for its realistic detail, Manet did not disguise the fact that it was composed in a studio using a model and props.",
    displayScore: 9.3,
    image: makeImage("The Spanish Singer", "Edouard Manet · 1860", "#1d3557", "#457b9d"),
    distribution: {
      Story: [2, 4, 10, 18, 26],
      Originality: [1, 6, 12, 18, 22],
      "Historical Context": [1, 3, 8, 16, 30],
      "Visual Impact": [0, 4, 9, 19, 24],
      Purpose: [2, 6, 12, 16, 21],
      "Overall Impression": [1, 4, 11, 20, 24]
    }
  },
  {
    id: 102,
    title: "Mao",
    artist: "Andy Warhol",
    date: "1973",
    medium: "Silkscreen",
    culture: "American",
    description:
      "A vivid silkscreen portrait representing the collision of mass media and politics.",
    image: makeImage("Mao", "Andy Warhol · 1973", "#ff9f1c", "#ff595e"),
    distribution: {
      Story: [0, 0, 0, 0, 0],
      Originality: [0, 0, 0, 0, 0],
      "Historical Context": [0, 0, 0, 0, 0],
      "Visual Impact": [0, 0, 0, 0, 0],
      Purpose: [0, 0, 0, 0, 0],
      "Overall Impression": [0, 0, 0, 0, 0]
    }
  },
  {
    id: 103,
    title: "Marble statue of a kouros (youth)",
    artist: "Unknown",
    date: "ca. 590–580 B.C.",
    medium: "Marble",
    culture: "Greek",
    description:
      "A refined example of early Greek sculpture. Used here as a neutral tone placeholder.",
    image: makeImage("Kouros (youth)", "Greek · 590–580 B.C.", "#d4c2a8", "#b58f6a"),
    distribution: {
      Story: [6, 12, 20, 16, 8],
      Originality: [2, 8, 16, 22, 12],
      "Historical Context": [1, 5, 11, 21, 26],
      "Visual Impact": [1, 6, 14, 24, 22],
      Purpose: [5, 11, 16, 18, 10],
      "Overall Impression": [4, 10, 15, 18, 14]
    }
  },
  {
    id: 104,
    title: "Night Harbor Study",
    artist: "Ava Collins",
    date: "1924",
    medium: "Oil on panel",
    culture: "British",
    description:
      "A moody harbor study that emphasizes light over detail for a contemplative tone.",
    image: makeImage("Night Harbor Study", "Ava Collins · 1924", "#0f2027", "#2c5364"),
    distribution: {
      Story: [5, 10, 14, 14, 9],
      Originality: [3, 9, 15, 18, 11],
      "Historical Context": [4, 9, 13, 16, 12],
      "Visual Impact": [2, 6, 14, 20, 17],
      Purpose: [4, 10, 14, 17, 11],
      "Overall Impression": [3, 8, 16, 19, 12]
    }
  },
  {
    id: 105,
    title: "Garden at Dusk",
    artist: "Luis Herrera",
    date: "1890",
    medium: "Oil on canvas",
    culture: "Spanish",
    description:
      "A quiet dusk scene that leans on color and balance rather than explicit narrative.",
    image: makeImage("Garden at Dusk", "Luis Herrera · 1890", "#355c7d", "#c06c84"),
    distribution: {
      Story: [7, 11, 16, 12, 8],
      Originality: [4, 9, 14, 15, 10],
      "Historical Context": [5, 10, 15, 16, 9],
      "Visual Impact": [2, 7, 15, 21, 14],
      Purpose: [6, 11, 14, 15, 8],
      "Overall Impression": [4, 9, 16, 17, 10]
    }
  },
  {
    id: 106,
    title: "Ceramic Vessel",
    artist: "Unknown",
    date: "1500",
    medium: "Ceramic",
    culture: "Peruvian",
    description:
      "A vessel with geometric motifs. The simplified imagery keeps the focus on structure.",
    image: makeImage("Ceramic Vessel", "Peruvian · 1500", "#f6d365", "#fda085"),
    distribution: {
      Story: [5, 9, 12, 10, 7],
      Originality: [3, 8, 12, 14, 9],
      "Historical Context": [2, 6, 12, 16, 12],
      "Visual Impact": [1, 6, 13, 18, 14],
      Purpose: [4, 9, 12, 13, 9],
      "Overall Impression": [3, 8, 13, 15, 11]
    }
  }
];

export const communityGoal = {
  totalOpenAccess: 32000,
  ratedCount: 834
};
